export default __webpack_public_path__ + "static/media/bsc-icon.65837241.svg";